/* eslint-disable */
// This code is autogenerated using @harnessio/oats-cli.
// Please do not modify this code directly.
import { fetcher, FetcherOptions } from './fetcher';

export interface VoiceProfileDestroyAPIPathParams {
  /**
   * @format uuid
   */
  id: string;
}

export type VoiceProfileDestroyOkResponse = unknown;

export type VoiceProfileDestroyErrorResponse = unknown;

export interface VoiceProfileDestroyProps
  extends VoiceProfileDestroyAPIPathParams,
    Omit<FetcherOptions<unknown, unknown>, 'url'> {}

export function voiceProfileDestroy(
  props: VoiceProfileDestroyProps
): Promise<VoiceProfileDestroyOkResponse> {
  return fetcher<VoiceProfileDestroyOkResponse, unknown, unknown>({
    url: `/voice_profile/${props.id}/`,
    method: 'DELETE',
    ...props
  });
}
